var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import '@gower/utils/extension';
import setup from './StateSetup';
import { Event } from "typescript.events";
import { Guid } from '@gower/utils';
var Wrapped = /** @class */ (function () {
    function Wrapped(store) {
        var _this = this;
        if (store)
            store.___base___destroy_wrapper = function () { _this.store = undefined; };
        this.store = store;
    }
    Object.defineProperty(Wrapped.prototype, "current", {
        get: function () {
            return this.store;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Wrapped.prototype, "isDestroyed", {
        get: function () {
            return typeof this.store === 'undefined';
        },
        enumerable: false,
        configurable: true
    });
    return Wrapped;
}());
export { Wrapped };
var MutableStore = /** @class */ (function () {
    function MutableStore(handler) {
        this.___internal___isMounted = false;
        this.___internal___isBeforeRender = false;
        this.___internal___isAfterRender = false;
        this.___internal___handler = handler;
    }
    MutableStore.prototype.___base__mounted = function (props) {
        this.setViewName((props === null || props === void 0 ? void 0 : props.viewName) || Guid(1, true).substring(5));
        this.___internal___isMounted = true;
    };
    MutableStore.prototype.___base___afterRender = function () {
        this.___internal___isAfterRender = true;
    };
    ;
    MutableStore.prototype.___base___beforeRender = function () {
        this.___internal___isBeforeRender = true;
    };
    ;
    MutableStore.prototype.___base___destroy = function () {
        this.___internal___handler.removeWatchers();
        this.___internal___isMounted = false;
        this.___internal___isBeforeRender = false;
        this.___internal___isAfterRender = false;
        this.___base___destroy_wrapper && this.___base___destroy_wrapper();
    };
    MutableStore.prototype.___internal___mounted = function (props) { };
    ;
    MutableStore.prototype.___internal___afterRender = function (props) { };
    ;
    MutableStore.prototype.___internal___beforeRender = function (props) { };
    ;
    MutableStore.prototype.___internal___receiveProps = function (props) { };
    ;
    MutableStore.prototype.___internal___destroy = function (props) { };
    ;
    MutableStore.prototype.onMounted = function (props) { };
    MutableStore.prototype.onBeforeRender = function (props) { };
    MutableStore.prototype.onAfterRender = function (props) { };
    MutableStore.prototype.onReceiveProps = function (props) { };
    MutableStore.prototype.onDestroy = function () { };
    Object.defineProperty(MutableStore.prototype, "viewName", {
        get: function () { return this.___internal___viewName; },
        enumerable: false,
        configurable: true
    });
    MutableStore.prototype.setViewName = function (v) {
        if (v && typeof v === 'string')
            this.___internal___viewName = v;
    };
    MutableStore.prototype.on = function (event, listener) {
        var _this = this;
        this.___internal___handler.on(event, listener);
        return {
            unsubscribe: function () { var _a; return (_a = _this.___internal___handler) === null || _a === void 0 ? void 0 : _a.removeListener(event, listener); }
        };
    };
    MutableStore.prototype.emit = function (event, data) {
        this.___internal___handler.emit(event, data);
    };
    MutableStore.prototype.removeListener = function (event, listener) {
        this.___internal___handler.removeListener(event, listener);
    };
    MutableStore.prototype.watch = function (key, fn) {
        this.___internal___handler.watch(key, fn);
    };
    MutableStore.prototype.watchNative = function (key, fn) {
        this.___internal___handler.watchNative(key, fn);
    };
    MutableStore.prototype.watchInternal = function (key, fn) {
        this.___internal___handler.watchInternal(key, fn);
    };
    MutableStore.prototype.watchInternalNative = function (key, fn) {
        this.___internal___handler.watchInternalNative(key, fn);
    };
    MutableStore.prototype.removeWatcher = function (keyPattern) {
        this.___internal___handler.removeWatcher(keyPattern);
    };
    return MutableStore;
}());
export { MutableStore };
var SubStore = /** @class */ (function (_super) {
    __extends(SubStore, _super);
    function SubStore() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SubStore.prototype, "MainStore", {
        get: function () { return this.___base___store; },
        enumerable: false,
        configurable: true
    });
    SubStore.prototype.___internal___mounted = function (props) {
        _super.prototype['___internal___mounted'] && _super.prototype['___internal___mounted'].call(this, props);
        this.___base___store = props.store;
    };
    return SubStore;
}(MutableStore));
export { SubStore };
var Handler = /** @class */ (function (_super) {
    __extends(Handler, _super);
    function Handler(store) {
        var _this = _super.call(this) || this;
        _this.watchers = [];
        _this._all_watchers = [];
        _this.changesBuffer = false;
        _this.storePrototype = store;
        _this.currentStore = new Wrapped(setup(_this, new store(_this)));
        return _this;
    }
    Handler.setup = function (store) {
        return new Handler(store);
    };
    Handler.prototype.getState = function () {
        return this.currentStore;
    };
    Object.defineProperty(Handler.prototype, "current", {
        get: function () {
            if (this.currentStore)
                return this.currentStore.store;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Handler.prototype, "isDetroyed", {
        get: function () {
            return !this.currentStore || this.currentStore.isDestroyed;
        },
        enumerable: false,
        configurable: true
    });
    Handler.prototype.hidrate = function () {
        if (this.isDetroyed) {
            this.currentStore = new Wrapped(setup(this, new this.storePrototype(this)));
            return true;
        }
    };
    Handler.prototype.watch = function (key, fn, substore) {
        if (substore === void 0) { substore = false; }
        var listenerName = 'hook-' + (substore ? 'substore-' : '') + key;
        this._all_watchers.push(listenerName);
        this.watchers.push(listenerName);
        this.on(listenerName, fn);
    };
    Handler.prototype.watchNative = function (key, fn, substore) {
        if (substore === void 0) { substore = false; }
        var listenerName = 'native-' + (substore ? 'substore-' : '') + key;
        this._all_watchers.push(listenerName);
        this.on(listenerName, fn);
    };
    Handler.prototype.watchInternal = function (key, fn, substore) {
        if (substore === void 0) { substore = false; }
        var listenerName = 'hook-internal-' + (substore ? 'substore-' : '') + key;
        this._all_watchers.push(listenerName);
        this.watchers.push(listenerName);
        this.on(listenerName, fn);
    };
    Handler.prototype.watchInternalNative = function (key, fn, substore) {
        if (substore === void 0) { substore = false; }
        var listenerName = 'native-internal-' + (substore ? 'substore-' : '') + key;
        this._all_watchers.push(listenerName);
        this.on(listenerName, fn);
    };
    Handler.prototype.subscribe = function (fn) {
        this.removeAllListeners(['storeChanged']);
        this.on('storeChanged', fn);
    };
    Handler.prototype.removeWatcher = function (keyPattern) {
        var finded = this._all_watchers.filter(function (key) {
            return key.startsWith('hook-' + keyPattern) ||
                key.startsWith('native-' + keyPattern) ||
                key.startsWith('hook-internal-' + keyPattern) ||
                key.startsWith('native-internal-' + keyPattern);
        });
        this.removeAllListeners(__spreadArray([], finded, true));
        this._all_watchers.remove(function (x) { return finded.some(function (a) { return a === x; }); });
    };
    Handler.prototype.removeWatchers = function () {
        this.removeAllListeners(__spreadArray([], this._all_watchers, true));
        this._all_watchers.clear();
    };
    Object.defineProperty(Handler.prototype, "currentStore", {
        get: function () { return this._currentStore; },
        set: function (store) {
            this._currentStore = store;
            if (!this.isDetroyed)
                this.currentStore.store.Handler = this;
        },
        enumerable: false,
        configurable: true
    });
    ;
    ;
    Handler.prototype.startChanges = function (keyChanged, newValue, oldValue) {
        var _this = this;
        var keys = keyChanged.split('.');
        if (keys.hasRows() && keys.length > 1) {
            var total = keys.length - 1;
            for (var i = 0; i < total; i++) {
                keys.splice(keys.length - 1, 1);
                var key2 = keys.join('.');
                this.emit('hook-internal-' + key2);
                this.emit('native-internal-' + key2);
                this.emit('hook-internal-substore-' + key2);
                this.emit('native-internal-substore-' + key2);
            }
        }
        this.emit('hook-' + keyChanged, newValue, oldValue);
        this.emit('native-' + keyChanged, newValue, oldValue);
        this.emit('hook-substore-' + keyChanged, newValue, oldValue);
        this.emit('native-substore-' + keyChanged, newValue, oldValue);
        if (!this.changesBuffer) {
            this.changesBuffer = true;
            setTimeout(function () {
                _this.onChange();
            }, 100);
        }
    };
    Handler.prototype.startChangesInmediate = function (keyChanged, newValue, oldValue) {
        var _this = this;
        var keys = keyChanged.split('.');
        if (keys.hasRows() && keys.length > 1) {
            var total = keys.length - 1;
            for (var i = 0; i < total; i++) {
                keys.splice(keys.length - 1, 1);
                var key2 = keys.join('.');
                this.emit('hook-internal-' + key2);
                this.emit('native-internal-' + key2);
                this.emit('hook-internal-substore-' + key2);
                this.emit('native-internal-substore-' + key2);
            }
        }
        this.emit('hook-' + keyChanged, newValue, oldValue);
        this.emit('native-' + keyChanged, newValue, oldValue);
        this.emit('hook-substore-' + keyChanged, newValue, oldValue);
        this.emit('native-substore-' + keyChanged, newValue, oldValue);
        if (!this.changesBuffer) {
            this.changesBuffer = true;
            setTimeout(function () {
                _this.onChange();
            }, 0);
        }
    };
    Handler.prototype.onChange = function () {
        //if ( process.browser )
        this.changesBuffer = false;
        this.currentStore = new Wrapped(this.currentStore.store);
        if (this.watchers.hasRows())
            this.removeAllListeners(__spreadArray([], this.watchers, true));
        this.emit('storeChanged', this.currentStore);
    };
    return Handler;
}(Event));
export { Handler };
var EditManager = /** @class */ (function () {
    function EditManager(___internal__store) {
        var handle = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            handle[_i - 1] = arguments[_i];
        }
        var _this = this;
        this.___internal__store = ___internal__store;
        this.___internal___properties = [];
        this.___internal___isEditing = false;
        if (handle === null || handle === void 0 ? void 0 : handle.length) {
            handle.forEach(function (key) { return _this.handle(key); });
        }
    }
    Object.defineProperty(EditManager.prototype, "isEditing", {
        get: function () { return this.___internal___isEditing; },
        set: function (v) { this.___internal___isEditing = v; },
        enumerable: false,
        configurable: true
    });
    EditManager.prototype.handle = function (properyName) {
        var _this = this;
        this.___internal___properties.push(properyName);
        this.___internal__store.watchNative(properyName, function () { _this.___internal___isEditing = true; });
        this.___internal__store.watchInternalNative(properyName, function () { _this.___internal___isEditing = true; });
        this.___internal___isEditing = false;
    };
    EditManager.prototype.remove = function (properyName) {
        this.___internal__store.removeWatcher(properyName);
        this.___internal___isEditing = false;
    };
    EditManager.prototype.unsubscribe = function () {
        var _this = this;
        this.___internal___properties.forEach(function (key) { return _this.___internal__store.removeWatcher(key); });
        this.___internal___isEditing = false;
    };
    EditManager.prototype.reset = function () {
        this.___internal___isEditing = false;
    };
    return EditManager;
}());
export { EditManager };
